'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwFlyout = require('../cwflyout/CwFlyout');

var _CwFlyout2 = _interopRequireDefault(_CwFlyout);

var _CwFlyoutComposer = require('./CwFlyoutComposer.scss');

var _CwFlyoutComposer2 = _interopRequireDefault(_CwFlyoutComposer);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _CustomPropTypeValidation = require('../../utils/CustomPropTypeValidation');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwFlyoutComposer = function (_React$Component) {
  (0, _inherits3.default)(CwFlyoutComposer, _React$Component);

  function CwFlyoutComposer() {
    (0, _classCallCheck3.default)(this, CwFlyoutComposer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CwFlyoutComposer.__proto__ || (0, _getPrototypeOf2.default)(CwFlyoutComposer)).call(this));

    _this.componentWillMount = function () {
      window.addEventListener('mousedown', _this.handleOnBlur);
    };

    _this.mouseDownHandler = function () {
      _this._ignoreBlur = true; // used for toggling flyout on click correctly
    };

    _this.mouseUpHandler = function () {
      _this._ignoreBlur = false; // used for toggling flyout on click correctly
    };

    _this.handleOnClick = function () {
      if (_this.props.widget.props.onClick) {
        _this.props.widget.props.onClick();
      }

      _this.getComponentCenter();

      _this.setState(function (prevState) {
        return { flyout: !prevState.flyout };
      });
    };

    _this.handleOnBlur = function () {
      if (_this.props.widget.props.onBlur) {
        _this.props.widget.props.onBlur();
      }

      if (_this._ignoreBlur) {
        return;
      }

      if (_this.state.flyout) {
        _this.setState({ flyout: false });
      }
    };

    _this.getComponentCenter = function () {
      var node = _this.component;
      var rect = node.getBoundingClientRect();

      _this._buttonX = rect.left + (rect.right - rect.left) / 2;
      _this._buttonY = rect.top + (rect.bottom - rect.top) / 2;
      _this.buttonX = node.offsetWidth / 2;
      _this.buttonY = node.offsetHeight;
    };

    _this._ignoreBlur = false;
    _this.buttonX = 0;
    _this.buttonY = 0;
    _this._buttonX = 0;
    _this._buttonY = 0;

    _this.state = {
      flyout: false
    };
    return _this;
  }

  (0, _createClass3.default)(CwFlyoutComposer, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('mousedown', this.handleOnBlur);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // we append onBlur/onClick props to the widget
      // ensure widget makes use of both props
      var widget = _react2.default.cloneElement(this.props.widget, {
        onClick: this.handleOnClick,
        onBlur: this.handleOnBlur
      });

      return _react2.default.createElement(
        'div',
        { 'data-cwid': this.props.cwId,
          onMouseDown: this.mouseDownHandler,
          onMouseUp: this.mouseUpHandler,
          className: (0, _classnames2.default)(_CwFlyoutComposer2.default.wrap, this.props.className),
          style: this.props.style },
        _react2.default.createElement(
          'div',
          { ref: function ref(input) {
              return _this2.component = input;
            } },
          widget
        ),
        this.state.flyout ? _react2.default.createElement(
          _CwFlyout2.default,
          {
            cwId: this.props.cwId + '_flyout',
            id: 0,
            header: this.props.header,
            subHeader: this.props.subHeader,
            x: this.buttonX,
            y: this.buttonY,
            xCoord: this._buttonX,
            yCoord: this._buttonY },
          this.props.flyout
        ) : null
      );
    }
  }]);
  return CwFlyoutComposer;
}(_react2.default.Component);

CwFlyoutComposer.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes2.default.string,
  /**
   * Override the styles of the root element
   */
  style: _propTypes2.default.object,
  /**
   * Optional header for the flyout
   */
  header: _propTypes2.default.string,
  /**
   * Optional subheader for the flyout
   */
  subHeader: _propTypes2.default.string,
  widget: (0, _CustomPropTypeValidation.componentHasPropTypes)(['onClick', 'onBlur']),
  flyout: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string])
};

exports.default = CwFlyoutComposer;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwflyoutcomposer/CwFlyoutComposer.js
// module id = 836
// module chunks = 10